import createNgModule from '../../lib/helpers/createNgModule';
import ManageAddressesController from './ManageAddressesController';

const moduleName = 'lt.manageAddresses';

const module = createNgModule(moduleName, ManageAddressesController);

export { moduleName as moduleName };
export default module;
